/**
 * A contract is on holdback while `holdbackUntil` is a date in the future or
 * the delivery shows a pause. `pausedUntil` alone is not enough: it is only set
 * when the chosen dispatch is beyond the club's next dispatch, so a holdback to
 * the next dispatch is only visible through `holdbackUntil`.
 */
export const isOnHoldback = ({ holdbackUntil, pausedUntil, }, now = new Date()) => {
    if (pausedUntil) {
        return true;
    }
    if (!holdbackUntil) {
        return false;
    }
    const holdbackUntilDate = new Date(holdbackUntil);
    return !Number.isNaN(holdbackUntilDate.getTime()) && holdbackUntilDate > now;
};
